<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ posicao_veiculo.posicao_veiculo_id ? "Editar" : "Nova" }}
                Posição
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Nome da Posição do
                          Veículo:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="posicao_veiculo.posicao_veiculo_nome"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Código da Posição do
                          Veículo:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="posicao_veiculo.posicao_veiculo_codigo"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Ordem:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="posicao_veiculo.ordem"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6 mt-2">
                        <div class="custom-control custom-switch">
                          <input
                            autocomplete="new-password"
                            v-model="posicao_veiculo.exibir_kanban"
                            placeholder=""
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch1"
                          />
                          <label
                            class="custom-control-label"
                            for="customSwitch1"
                            >Exibir Kanban?</label
                          >
                        </div>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Cor:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="color"
                          id="Name"
                          class="form-control"
                          v-model="posicao_veiculo.color"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6 mt-2">
                        <div class="custom-control custom-switch">
                          <input
                            autocomplete="new-password"
                            v-model="posicao_veiculo.show_index_page"
                            placeholder=""
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch2"
                          />
                          <label
                            class="custom-control-label"
                            for="customSwitch2"
                            >Exibir na Página de Atendimentos?</label
                          >
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Status:
                        </label>
                        <select
                          v-model="posicao_veiculo.status"
                          class="form-control"
                        >
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link
                        to="/posicao_veiculo"
                        class="btn btn-back mr-1"
                      >
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      posicao_veiculo: {
        posicao_veiculo_nome: "",
        posicao_veiculo_codigo: "",
        ordem: "",
        status: "1",
        exibir_kanban: "",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "posicao_veiculo";

      if (self.posicao_veiculo.posicao_veiculo_id) {
        self.posicao_veiculo._method = "PUT";
        api += "/" + self.posicao_veiculo.posicao_veiculo_id;
      }

      axios
        .post(api, self.posicao_veiculo)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/posicao_veiculo");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPosicaoVeiculo: function (id) {
      const self = this;
      const api = self.$store.state.api + "posicao_veiculo/" + id;

      axios
        .get(api)
        .then((response) => {
          self.posicao_veiculo = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getPosicaoVeiculo(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>